import Popover from "./Popover"
import Disclosure from "./PopoverDisclosure"

export default Object.assign(Popover, {
  Disclosure
})
